<template>
  <div>
    <div class="idx-class-img" v-if="(recommend.idx==23 || recommend.idx==27)" @click="gotoRecoment()">
      <img :src="recommend.imgUrl"/>
    </div>
    <div class="idx-class-head" v-else>
      <div class="idx-class-head-head" @click="gotoRecoment()">
        <div class="idx-class-head-head-left">
          <!--<img :src="img"/>-->
          <span :class="img">{{recommend.title}}</span>
        </div>
        <div class="idx-class-head-head-right">
          <span>查看更多 >></span>
        </div>
        <div style="clear:both"></div>
      </div>
      <div class="idx-class-head-foot" v-if="(recommend.idx==public.classIdx.onePrice || recommend.idx==public.classIdx.chaozhi)">
        <v-swiper :recommend="recommend" :type="headType.h5Main">
          <div style="clear:both;"></div>
        </v-swiper>
      </div>
      <div class="top-foot" v-else>
        <div>
          <div :class="getTopBodyClass(index+1,recommend.pList.length)" :style="bodyStyle" v-first.once="index" v-for="(p,index) in getArray(recommend.pList)" @click="public.gotoDetail(p,headType.h5Main,0,index)" >
            <div :class="topNumCss">
              <span>{{index+1}}</span>
            </div>
            <div class="top-foot-body-head">
              <img :src="updatePicSrc(p.Pic)"/>
            </div>
            <div class="top-foot-body-body">
              <span>{{p.sTitle?p.sTitle:p.Title}}</span>
            </div>
            <div class="top-foot-body-foot">
              <div class="top-foot-body-foot-left">
                <span>¥{{p.Price}}</span>
              </div>
              <div class="top-foot-body-foot-right">
                <span>{{p.Quan_price |subPrice}}元券</span>
              </div>
            </div>
          </div>
          <div style="clear:both"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import RecommendSwiper from "./RecommendSwiper.vue";
  export default{
    name:'IdxClass',
    props:['recommend'],
    data(){
      return {
        img:"",
        bodyStyle:{"width":(window.innerWidth-5)/4+"px"},
        topNumCss:""
      }
    },
    created(){
      switch (this.recommend.idx){
        case this.public.classIdx.onePrice:{
          this.img="idx-head-left-span-oneprice";
          break;
        }
        case this.public.classIdx.chaozhi:{
          this.img="idx-head-left-span-chaozhi";
          break;
        }
        case this.public.classIdx.top:{
          this.img="idx-head-left-span-top";
          break;
        }
        default:{

        }
      }
      if(this.isIos){
        this.topNumCss = "top-num-ios";
      }else{
        this.topNumCss = "top-num-android";
      }
    },
    filters:{
      subPrice:function(value){
        if(typeof value!='string'){
          value = value.toString();
        }
        var idx = value.indexOf(".");
        if(idx>-1){
          value = value.slice(0,idx);
        }
        return value;
      }
    },
    directives: {
      first: {
        bind: function (el, binding, vnode) {
        }
      }
    },
    mounted(){},
    components:{
      'v-swiper':RecommendSwiper
    },
    methods:{
      getTopBodyClass(index,len){
        let css = "top-foot-body";
        let l = len>8?8:len;
        if(l-index>=4 && (index-1)%4==0){
          return css +" top-border-one-head";
        }else if(l-index<4 && (index-1)%4==0){
          return css +" top-border-two-head";
        }else if(l-index<4){
          return css +" top-border-two-other";
        }else{
          return css +" top-border-one-other";
        }
      },
      gotoRecoment(){
        let title = this.recommend.title;
        if(this.recommend.idx==23 || this.recommend.idx==27){
          title = typeof this.recommend.desc!='undefined' && this.recommend.desc!=''?this.recommend.desc:this.recommend.title;
        }
        this.jumpToView(this.headType.recommend,this.recommend.param,title);
      },
      getArray(array){
        if(array && array.length>8){
          return array.slice(0,8);
        }else{
          return array;
        }

      },
      updatePicSrc(pic){
        let src = pic.replace("http://","//").replace("https://","//");
        if(src.indexOf("taobaocdn.") > -1){
          src = src.split("taobaocdn.")[1];
          src = "//img.alicdn."+src;
        }
        if(src.indexOf("alicdn") > -1){
          src += "_300x300.jpg";
        }
        return src;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// IdxClass.vue?717cd435